import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {getConversations} from '../../../store/data/dataSelectors';
import {getHasQuoteComment} from '../../../store/featureFlags/featureFlagsSelectors';
import {ViewerPanelId} from '../../../store/panels/panelStateBase';
import {jumpToActivityAction} from '../../../store/panels/viewer/viewerPanelActions';
import {AnnotationsHighlightViewer} from './annotationsHighlightViewer';

/*
 * Props.
 */

interface AnnotationsHighlightViewerContainerProps {
  conversationId: number;
  isAnnotatingComment?: boolean;
}

/*
 * Selectors.
 */

function getConversationId(_state: AppState, props: AnnotationsHighlightViewerContainerProps) {
  return props.conversationId;
}

function makeGetNamespace() {
  return createSelector(
    [getConversations, getConversationId],
    (conversations, conversationId) =>
      (conversationId && conversations[conversationId]?.namespace) || undefined,
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<AnnotationsHighlightViewerContainerProps>()(() => ({
  conversationId: getConversationId,
  hasQuoteComment: getHasQuoteComment,
  namespace: makeGetNamespace(),
}));

const dispatchProps = {
  onJumpToActivity: (value: {panelId: ViewerPanelId; sourceActivityId: number}) =>
    jumpToActivityAction(value.panelId, {id: value.sourceActivityId}),
};

export const AnnotationsHighlightViewerContainer = connect(
  mapStateToProps,
  dispatchProps,
)(AnnotationsHighlightViewer);
